@if (fillParent) {
    <div class="webcam-wrapper">
        <div class="pol-preview-stage">
            <div class="pol-preview-zoom" [ngStyle]="wrapperZoomStyle">
                <video #videoElement id="video" autoplay playsinline muted (click)="onVideoTap($event)"></video>
            </div>
            <canvas
                #canvasElement
                id="controlCanvas"
                class="pol-debug-overlay"
                [ngClass]="{ output_canvas: debugMode }"
                [ngStyle]="{ visibility: debugMode ? 'visible' : 'hidden' }"
                [style]="canvasStyle"
            ></canvas>
        </div>
    </div>
} @else {
    <div
        [ngClass]="{ 'webcam-container': debugMode }"
        [ngStyle]="{
            transform:
                zoomFactor === 1 && !zoomOffsetX && !zoomOffsetY
                    ? 'none'
                    : 'scale(' + zoomFactor + ') translateX(' + zoomOffsetX + 'px) translateY(' + zoomOffsetY + 'px)',
            'transform-origin': zoomTransformOrigin
        }"
    >
        <div [ngClass]="{ 'webcam-container': debugMode, 'flip-horizontal': flipHorizontal }">
            <video #videoElement id="video" autoplay playsinline muted (click)="onVideoTap($event)"></video>
            <canvas
                #canvasElement
                id="controlCanvas"
                [ngClass]="{ output_canvas: debugMode }"
                [ngStyle]="{ visibility: debugMode ? 'visible' : 'hidden' }"
                [style]="canvasStyle"
            ></canvas>
        </div>
    </div>
}
